import { render } from "./ServerUnavailable.vue?vue&type=template&id=2d60c200"
import script from "./ServerUnavailable.vue?vue&type=script&lang=js"
export * from "./ServerUnavailable.vue?vue&type=script&lang=js"

import exportComponent from "H:\\Projects\\Jesta\\Front\\Jesta-Group\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__